import React, { useEffect } from 'react';

const getInitialValue = (key, defaultValue) => {
  const storedValue = localStorage.getItem(key);
  if (storedValue === 'true') return true;
  if (storedValue === 'false') return false;
  return storedValue || defaultValue;
};

export const usePersistedState = (key, defaultValue) => {
  const [state, setState] = React.useState(() => getInitialValue(key, defaultValue));

  useEffect(() => {
    localStorage.setItem(key, state);
  }, [key, state]);

  return [state, setState];
};
